export class ControleManquementEdition {
    static jsonMap = {
        id: { key: 'id', optional: true },
        numero: { key: 'numero', optional: true, default: '' },
        motif: { key: 'motif', optional: true, default: '' },
        observation: { key: 'observation', optional: true, default: '' },
        auteurConstat: { key: 'auteurConstat', optional: true, default: '' },
        fonctionAuteur: { key: 'fonctionAuteur', optional: true, default: '' },
        idAuteurConstat: { key: 'idAuteurConstat', optional: true }
    };

    id: number;
    numero: string;
    motif: string;
    observation: string;
    auteurConstat: string;
    fonctionAuteur: string;
    idAuteurConstat: number;
}
